/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type FetchJiraServerOAuthUrlInput = {
    jiraServerUrl?: string | null | undefined;
    clientId?: string | null | undefined;
    clientSecret?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type fetchJiraServerOauthUrlMutationVariables = {
    input: FetchJiraServerOAuthUrlInput;
};
export type fetchJiraServerOauthUrlMutationResponse = {
    readonly fetchJiraServerOAuthUrl: {
        readonly url: string | null;
        readonly token: string | null;
        readonly token_secret: string | null;
        readonly errors: string | null;
    } | null;
};
export type fetchJiraServerOauthUrlMutation = {
    readonly response: fetchJiraServerOauthUrlMutationResponse;
    readonly variables: fetchJiraServerOauthUrlMutationVariables;
};



/*
mutation fetchJiraServerOauthUrlMutation(
  $input: FetchJiraServerOAuthUrlInput!
) {
  fetchJiraServerOAuthUrl(input: $input) {
    url
    token
    token_secret
    errors
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "FetchJiraServerOAuthUrlInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "FetchJiraServerOAuthUrlPayload",
    "kind": "LinkedField",
    "name": "fetchJiraServerOAuthUrl",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token_secret",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "fetchJiraServerOauthUrlMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "fetchJiraServerOauthUrlMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "fetchJiraServerOauthUrlMutation",
    "operationKind": "mutation",
    "text": "mutation fetchJiraServerOauthUrlMutation(\n  $input: FetchJiraServerOAuthUrlInput!\n) {\n  fetchJiraServerOAuthUrl(input: $input) {\n    url\n    token\n    token_secret\n    errors\n  }\n}\n"
  }
};
})();
(node as any).hash = '64d67d800f11a98e9ba92d32022c74fa';
export default node;
